function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  fill: "none",
  cx: 50,
  cy: 50,
  r: 47.5,
  stroke: "#32c8ff",
  strokeWidth: 0.5
});

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  fill: "none",
  className: "st0",
  cx: 50,
  cy: 50,
  r: 48.2,
  stroke: "#32c8ff",
  strokeWidth: 1.7
});

function SvgLoaderFrame(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeD0iMCIgeT0iMCIgdmlld0JveD0iMCAwIDEwMCAxMDAiIHhtbDpzcGFjZT0icHJlc2VydmUiPgogICAgPGNpcmNsZSBmaWxsPSJub25lIiBjeD0iNTAiIGN5PSI1MCIgcj0iNDcuNSIgc3Ryb2tlPSIjMzJjOGZmIiBzdHJva2Utd2lkdGg9IjAuNSIgLz4KICAgIDxjaXJjbGUgZmlsbD0ibm9uZSIgY2xhc3M9InN0MCIgY3g9IjUwIiBjeT0iNTAiIHI9IjQ4LjIiIHN0cm9rZT0iIzMyYzhmZiIgc3Ryb2tlLXdpZHRoPSIxLjciIC8+Cjwvc3ZnPg==";
export { SvgLoaderFrame as ReactComponent };